// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c4bd7d7a","455":"44e755d1","977":"20e5b61c"}[chunkId] + ".chunk.js";
};